<div class="tt-resource-tag-list" [class.tt-resource-tag-list--readonly]="readonly()">
  @for (tag of tags(); track tag.id) {
    <tt-resource-tag-chip
      class="tt-resource-tag-list_item"
      [class.tt-resource-tag-list_item--editable]="!readonly()"
      [customBackgroundColor]="tag.backgroundColor"
      [customColor]="tag.color"
      [label]="tag.label">
      {{ tag.label }}
      @if (!readonly()) {
        <mat-icon [icon]="'x'" [iconSize]="14" (click)="removeTag($event, tag)" />
      }
    </tt-resource-tag-chip>
  }
</div>
